<template>
  <div>
    <h2>{{ $t("menu.news") }}</h2>
    <subscribe-newsletter></subscribe-newsletter>
    <blog-list :forceAll="true"></blog-list>
  </div>
</template>

<script>
import BlogList from "./BlogList.vue";
import SubscribeNewsletter from "./SubscribeNewsletter.vue";

export default {
  name: "BlogFullList",
  components: {
    BlogList,
    SubscribeNewsletter
  },
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  padding-top: 15px;
}
</style>
